const getError = async (res) => {
  if (!res) throw new Error('RMS API error: no response received')

  let error
  try {
    error = await res.json()
  } catch (jsonError) {
    const err = new Error(`RMS API error: ${res.status} ${res.statusText}`)
    err.status = res.status
    throw err
  }

  let message = error.message || `RMS API error: ${res.status} ${res.statusText}`

  if (error.errors) {
    const details = Object.entries(error.errors)
      .map(([key, messages]) => `${key}: ${messages.join(', ')}`)
      .join('; ')
    message = `${message}: ${details}`
  }

  const err = new Error(message)
  err.status = res.status
  throw err
}

module.exports = getError
